import React from 'react'
import { Navigate } from 'react-router-dom';
import {useAuth} from '../../contexts/AuthContext';

export default function AdminRoute({ component: Component, ...rest }) {
    const {currentUser, isAdmin} = useAuth();

    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    if (!isAdmin) {
        return <Navigate to="/" />;
    }

    return <Component {...rest} />;
}
